import React, { useState } from 'react';
import { FormControlLabel, FormGroup, Grid, Switch } from '@mui/material';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';
import _ from 'lodash';
import { useNotifications } from 'modules/notification';

const M_UPDATE_VP = gql`
  mutation ($entityId: String!, $fieldsObj: UpdateVendorProfileInput!) {
    updateVendorProfile(entityId: $entityId, fieldsObj: $fieldsObj) {
      id
    }
  }
`;

export default function LenderDocumentAccess({
  vendorProfile,
  userProfile,
  vendorContactRoles,
  isSuperAdminOrSingleAccount,
}) {
  const { showNotification } = useNotifications();

  const [updateVpSettingMutation] = useMutation(M_UPDATE_VP);
  const [showLenderDocsAccessMgmt, setShowLenderDocsAccessMgmt] = useState(vendorProfile.showLenderDocsAccessMgmt);

  const isContentAvailableForUser =
    isSuperAdminOrSingleAccount ||
    _.includes([vendorContactRoles.sales_rep, vendorContactRoles.sales_mgr], userProfile?.vendorContactRole);

  if (!isContentAvailableForUser) return null;

  return (
    <div>
      {vendorProfile && (
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item lg={5} xl={5} xs={6}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <FormGroup row>
                  <FormControlLabel
                    label="Enable Enhanced Document Access Control"
                    control={
                      <Switch
                        color="primary"
                        checked={showLenderDocsAccessMgmt}
                        onChange={() => {
                          const newState = !showLenderDocsAccessMgmt;

                          updateVpSettingMutation({
                            variables: {
                              entityId: vendorProfile.id,
                              fieldsObj: { showLenderDocsAccessMgmt: newState },
                            },
                          }).then(() => {
                            showNotification('Dealer Document Access Control Setting successfully updated');
                          });

                          setShowLenderDocsAccessMgmt(newState);
                        }}
                      />
                    }
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </div>
  );
}
